'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// /~/react-dom/index.js
// module id = 21
// module chunks = 0